import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useEffect, useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { AddListingInitializeType } from '~addListing/types';
import { useTranslation } from 'react-i18next';

const MarkerIcon = `${process.env.PUBLIC_URL}/assets/marker-icon.png`;

const customIcon = L.icon({
  iconUrl: MarkerIcon,
  iconSize: [36, 44],
  iconAnchor: [15, 40],
});

L.Marker.prototype.options.icon = customIcon;

const MapUpdater = ({ position }: { position: L.LatLngExpression }) => {
  const map = useMap();

  useEffect(() => {
    map.setView(position, map.getZoom(), { animate: true });
  }, [position, map]);

  return null;
};

const ListingMap = ({
  setValue,
  locationPosition,
}: {
  setValue: UseFormSetValue<AddListingInitializeType>;
  locationPosition?: { lat: number; lng: number };
}) => {
  const initialPosition: L.LatLngExpression = [30.033333, 31.233334];
  const [position, setPosition] = useState<L.LatLngExpression>(initialPosition);
  const { t } = useTranslation('app');

  const handleDragEnd = (event: L.LeafletEvent) => {
    const marker = event.target as L.Marker;
    const newPosition = marker.getLatLng();
    setPosition([newPosition.lat, newPosition.lng]);
    setValue('centerLat', newPosition.lat);
    setValue('centerLng', newPosition.lng);
  };

  useEffect(() => {
    if (locationPosition?.lat && locationPosition?.lng)
      setPosition([locationPosition.lat, locationPosition.lng]);
  }, [locationPosition?.lat, locationPosition?.lng]);

  return (
    <div className="flex flex-col gap-1.5x">
      <p className="text-title_4">{t('locationOfPropertyOnMap')}</p>
      <div className="rounded-[12px]">
        <MapContainer
          center={position}
          zoom={15}
          scrollWheelZoom={true}
          className="h-[264px] rounded-[12px] z-[1]"
        >
          <MapUpdater position={position} />

          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker
            position={position}
            icon={customIcon}
            draggable={true}
            eventHandlers={{
              dragend: handleDragEnd,
            }}
          />
        </MapContainer>
      </div>
    </div>
  );
};

export default ListingMap;
